import { Button, notification } from "antd";
import React, { useEffect, useState } from "react";
import useToggle from "../../../shared/hook/useToggle";
import DataTable from "./dataTable";
import { GET } from "../../../utils/apiCalls";
import API from "../../../config/API";
import PurityAddModal from "./addpuritymodal";

function Purity() {
  const [toggle, toggleModal] = useToggle(false);
  const [data, setData] = useState<any[]>([]);
  const [loading, setLoading] = useState(true);
  const [Notifications, contextHolder] = notification.useNotification();

  const getPurity = async () => {
    const url = API.GET_PURITY_ALL;
    try {
      const response: any = await GET(url, null);
      if (response?.status) {
        setData(response.data);
      } else {
        Notifications["error"]({
          message: response?.message ?? "",
          description: "",
        });
      }
    } catch (err) {
      Notifications["error"]({
        message: `Something went wrong..`,
        description: "",
      });
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getPurity();
  }, []);
  return (
    <>
      {contextHolder}
      <Button
        onClick={() => {
          toggleModal(true);
        }}
        type="primary"
      >
        Add Purity +
      </Button>
      <DataTable data={data} loading={loading} getPurity={getPurity} />
      <PurityAddModal
        open={toggle}
        close={() => toggleModal(false)}
        refresh={() => getPurity()}
      />
    </>
  );
}

export default Purity;
